import {Injectable, NgModule} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpEvent,
    HttpSentEvent,
    HttpHandler,
    HTTP_INTERCEPTORS,
    HttpHeaderResponse,
    HttpProgressEvent,
    HttpResponse,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LocalStorageService} from "./local_storage.service";

@Injectable({
    providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {

    constructor(
        private localStorage: LocalStorageService,
    ) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<| HttpSentEvent
        | HttpHeaderResponse
        | HttpProgressEvent
        | HttpResponse<any>
        | HttpEvent<any>> {
        let customizedRequest;

        if (
            request.headers &&
            request.headers.get('Authorization') === 'IM'
        ) {
            customizedRequest = request.clone({
                headers: request.headers.set('Authorization', '')
            });
        } else if (this.localStorage.read('common/token')) {
            customizedRequest = request.clone({
                headers: request.headers.set('Authorization', this.localStorage.read(
                    'common/token'
                ))
            });
        } else {
            customizedRequest = request;
        }

        return next.handle(customizedRequest);
    }
}

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
    ],
})
export class AuthInterceptorModule {
}



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/auth-interceptor.service.ts